import React, { PureComponent } from 'react';
import { Route, Redirect } from 'react-router-dom';
import getCurrentRoute from './get-current-route';

export class NotFound extends PureComponent {
  redirectToParentCategory(props) {
    return <Redirect to={`/category/${props.match.params.cat1}/`} />;
  }
  redirectToRoot() {
    return <Redirect to={'/'} />;
  }
  render() {
    const currentRoute = getCurrentRoute();
    var url_parts = currentRoute.replace(/\/\s*$/, '').split('/');
    url_parts.shift();
    return url_parts.length === 3 && url_parts[0] === 'category' ? (
      <Route
        exact
        path="/category/:cat1/:cat2"
        render={this.redirectToParentCategory}
      >
        {this.forceUpdate()}
      </Route>
    ) : (
      <Route exact render={this.redirectToRoot} />
    );
  }
}

export default NotFound;
